import React from 'react'
import { createRoot } from 'react-dom/client'

import FundWatchList from './FundWatchList.jsx'

const fundsList = document.getElementById('fund-watch-list')

const root = createRoot(fundsList)
root.render(<FundWatchList />)
